module.exports = __webpack_public_path__ + "img/chris.01345b56.png";